import React, { useEffect, useState, useRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Accordion from '../../components/Accordian'
import { FeatureBlockMedia, FeatureBlockMediaContainer } from './blockMedia'

const FeatureBlock = ({ description, label, mediaPlacement, items, title }) => {
   const lastActiveIndex = useRef(0)
   const [activeIndex, setActiveIndex] = useState(null)
   const activeFeatureKeyName = items[activeIndex]?.key || 'blank'
   const blockRef = useRef(null)

   useEffect(() => {
      // eslint-disable-next-line no-undef
      const observer = new IntersectionObserver(
         (entries) => {
            if (entries[0].isIntersecting) {
               setActiveIndex(lastActiveIndex.current)
            } else {
               setActiveIndex(null)
            }
         },
         {
            threshold: 0.1
         }
      )

      if (blockRef.current) {
         observer.observe(blockRef.current)
      }

      return () => {
         observer.disconnect()
      }
   }, [])

   return (
      <div className="communities-content-wrapper" ref={blockRef}>
         <div className="w-full flex justify-center">
            <div
               className={classNames(
                  'w-full md:w-[560px] lg:w-full flex gap-4 md:gap-8 lg:gap-16 pb-8 md:pb-40 lg:pb-80',
                  mediaPlacement === 'left'
                     ? 'flex-col-reverse lg:flex-row'
                     : 'flex-col-reverse lg:flex-row-reverse'
               )}>
               <div className="flex-0 w-full md:w-[560px] lg:w-[55%] xl:w-[50%]">
                  <div className="relative w-full aspect-square rounded-[50px] md:rounded-[100px] overflow-hidden">
                     <FeatureBlockMediaContainer featureKeyName={activeFeatureKeyName}>
                        {items.map((item, index) => (
                           <FeatureBlockMedia
                              key={item.key}
                              featureKeyName={item.key}
                              active={activeIndex === index}
                           />
                        ))}
                     </FeatureBlockMediaContainer>
                  </div>
               </div>
               <div className="flex-0 w-full md:w-[560px] lg:w-[45%] xl:w-[50%] text-white">
                  <div className="text-base tracking-tight opacity-50 mb-2">{label}</div>
                  <div className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl leading-[1.1] tracking-tighter font-semibold mb-4">
                     {title}
                  </div>
                  <div className="text-base opacity-70">{description}</div>
                  <div className="flex flex-col text-base mt-12">
                     <Accordion
                        activeIndex={activeIndex || lastActiveIndex.current}
                        items={items}
                        onItemClick={(newIndex) => {
                           setActiveIndex(newIndex)
                           lastActiveIndex.current = newIndex
                        }}
                     />
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

FeatureBlock.propTypes = {
   description: PropTypes.string.isRequired,
   label: PropTypes.string.isRequired,
   mediaPlacement: PropTypes.oneOf(['left', 'right']),
   // eslint-disable-next-line react/forbid-prop-types
   items: PropTypes.array.isRequired,
   title: PropTypes.string.isRequired
}

FeatureBlock.defaultProps = {
   mediaPlacement: 'left'
}

export default FeatureBlock
